import { useState } from "react";
import Dialog from "../../Common/Dailog/Dailog";
import FullScreenLoader from "../../Common/ScreenLoader/FullScreenLoader";
import { Typography } from "@mui/material";
import {
  DELETE_TYPE_NAME,
  ENABLE_DISABLE_TYPE_NAME,
} from "../../../constants/loyaltyConstant";
import customConfig from "../../../config";
import {
  deleteLoyaltySpecData,
  updateLoyaltySpecData,
} from "../../../services/loyaltySpecService";

const ActionsSpec = ({ open, onClose, actionsData, feedbackHandler }) => {
  const [loading, setLoading] = useState(false);
  const [msgToDisplay, setMsgToDisplay] = useState("");

  const handleClickAction = async () => {
    let body = {
      action: actionsData?.data?.action?.trim()?.toLocaleLowerCase(),
      enabled: actionsData?.data?.enabled,
    };

    setLoading(true);
    //Delete action is performing
    if (actionsData?.type === DELETE_TYPE_NAME) {
      setMsgToDisplay(customConfig?.DELETING_DATA);
    }
    //Enable/Disable is performing
    else if (actionsData?.type === ENABLE_DISABLE_TYPE_NAME) {
      setMsgToDisplay(customConfig?.UPDATING_STATUS);
      //Disable is performing
      if (actionsData?.data?.enabled === true) {
        body["enabled"] = false;
      }
      //Enable is performing
      else if (actionsData?.data?.enabled === false) {
        body["enabled"] = true;
      }
    }

    try {
      let response = null;
      if (actionsData?.type === DELETE_TYPE_NAME) {
        response = await deleteLoyaltySpecData({ body });
      } else if (actionsData?.type === ENABLE_DISABLE_TYPE_NAME) {
        response = await updateLoyaltySpecData({ body });
        if (response?.success) {
            if(body["enabled"]===false){
                response['message'] = customConfig?.DISABLE_SUCCESS;
            }
            else if(body["enabled"]===true){
                response['message'] = customConfig?.ENABLE_SUCCESS;
            }
        }
      }

      if (response) {
        setMsgToDisplay(response?.message);
        setLoading(false);
        if (response?.success) {
          feedbackHandler({
            open: true,
            type: "success",
            msg: response?.message,
          });
          onClose(response);
        } else {
          feedbackHandler({
            open: true,
            type: "error",
            msg: response?.message,
          });
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        actionsData?.type === DELETE_TYPE_NAME
          ? "Delete Spec?"
          : actionsData?.data?.enabled
            ? "Disable Spec?"
            : "Enable Spec?"
      }
      maxWidth="xs"
      // fullWidth = {false}
      actions={[
        { label: "Cancel", variant: "ghost", onClick: onClose },
        {
          label:
            actionsData?.type === DELETE_TYPE_NAME
              ? "Delete"
              : actionsData?.data?.enabled
                ? "Disable"
                : "Enable",
          tooltip:
            actionsData?.type === DELETE_TYPE_NAME
              ? "Click to delete the spec."
              : actionsData?.data?.enabled
                ? "Click to disable the spec."
                : "Click to enable the spec.",
          variant: "primary",
          onClick: handleClickAction,
          slotProps: {
            popper: {
              sx: { zIndex: 2400 },
            },
          },
        },
      ]}
      sx={{
        zIndex: 2300,
      }}
    >
      {loading && <FullScreenLoader message={msgToDisplay} />}

      {actionsData?.type === DELETE_TYPE_NAME ? (
        <Typography>
          Are you sure you want to delete this loyalty spec?
        </Typography>
      ) : (
        <Typography>
          {actionsData?.data?.enabled
            ? "Are you sure you want to disable this loyalty spec?"
            : "Are you sure you want to enable this loyalty spec?"}
        </Typography>
      )}
    </Dialog>
  );
};

export default ActionsSpec;
